import { Button, Card, Descriptions } from 'antd';
import clsx from 'clsx';
import { map } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useMedia } from 'react-use';
import useQueryWithCallbacks from '../../../../../../../common/CommonUseQuery';
import {
  BREAKPOINTS,
  DATETIMEWITHDIVIDE,
  PROJECT_CHECKLIST_STATUS,
} from '../../../../../../../common/constants';
import EllipsisText from '../../../../../../../components/EllipsisText';
import { GET_PROJECT_EQC_TYPE_VERSION_LOGS } from '../../../../../graphql/Queries';
import VersionLogCard from './VersionLogCard';

const INITIAL_VISIBLE_COUNT = 3;

const ChangeLog = ({ eqcTypeData }) => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  const [expandedCards, setExpandedCards] = useState({});

  const { data, loading } = useQueryWithCallbacks(
    GET_PROJECT_EQC_TYPE_VERSION_LOGS,
    {
      variables: { id: eqcTypeData?.id },
      fetchPolicy: 'network-only',
      onCompleted: () => {},
      onError() {},
    },
  );

  const toggleCard = (idx) => {
    setExpandedCards((prev) => ({
      ...prev,
      [idx]: !prev?.[idx],
    }));
  };

  return (
    <>
      <h2>Version Change Log</h2>
      {map(data?.getProjectEqcTypeVersionLogs?.data, (versionData, idx) => {
        const isExpanded = expandedCards?.[idx] ?? false;
        const updates = versionData?.data ?? [];
        const hasMore = updates?.length > INITIAL_VISIBLE_COUNT;
        const visibleUpdates = isExpanded
          ? updates
          : updates?.slice(0, INITIAL_VISIBLE_COUNT);

        return (
          <Card
            className="change-log-module mt-24"
            loading={loading}
            id={`changelog-card-version-${idx}`}
          >
            <Descriptions
              column={isDesktopViewport ? 4 : 1}
              layout="vertical"
              colon={false}
              className="d-flex"
              id={`changelog-descriptions-version-${idx}`}
            >
              <Descriptions.Item
                label={
                  versionData?.status === PROJECT_CHECKLIST_STATUS.ARCHIVED
                    ? 'Made archived by'
                    : 'Made live by'
                }
                className={clsx(!isDesktopViewport && 'common-item')}
              >
                <EllipsisText text={versionData?.publishedBy || '-'} />
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  versionData?.status === PROJECT_CHECKLIST_STATUS.ARCHIVED
                    ? 'Made archived on'
                    : 'Made live on'
                }
              >
                {versionData?.publishedOn
                  ? moment(versionData?.publishedOn).format(DATETIMEWITHDIVIDE)
                  : '-'}
              </Descriptions.Item>
            </Descriptions>
            {updates?.length > 0 && (
              <>
                <h4 className="mt-16">Updates</h4>
                {map(visibleUpdates, (record, index) => {
                  return <VersionLogCard key={index} data={record} />;
                })}
                {hasMore && (
                  <Button
                    type="link"
                    className="change-log-view-toggle"
                    onClick={() => toggleCard(idx)}
                  >
                    {isExpanded ? 'View Less' : 'View More'}
                  </Button>
                )}
              </>
            )}
          </Card>
        );
      })}
    </>
  );
};

export default ChangeLog;
